import axios, { AxiosResponse } from 'axios'
import { getAppBaseUrl } from './api'

const baseURL = getAppBaseUrl()

export const getQaiModels = (): Promise<AxiosResponse> => {
    return axios.get(`${baseURL}/qai/models`)
}

export const getQaiModelDetail = (agentKey: string): Promise<AxiosResponse> => {
    return axios.get(`${baseURL}/qai/models/${encodeURIComponent(agentKey)}`)
}

export const syncAllQaiModels = (): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/qai/models/sync`)
}

export const syncQaiModelDetail = (agentKey: string): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/qai/models/${encodeURIComponent(agentKey)}/sync`)
}

export default {
    getQaiModels,
    getQaiModelDetail,
    syncAllQaiModels,
    syncQaiModelDetail
}
